import React from "react";
import { connect, useSelector } from "react-redux";

import { InfoIcon, MapIcon } from "@nens/ranalib";

import DischargeIcon from "../icons/discharge_icon.svg?react";
import DownloadIcon from "../icons/download_icon.svg?react";
import LeveeEditIcon from "../icons/levee_edit_icon.svg?react";
import LineIcon from "../icons/line_icon.svg?react";
import PumpIcon from "../icons/pump_icon.svg?react";
import RainIcon from "../icons/rain_icon.svg?react";
import RasterEditIcon from "../icons/rasteredit_icon.svg?react";
import SelectionToolIcon from "../icons/selectiontool_icon.svg?react";
import WindIcon from "../icons/wind_icon.svg?react";
import { removeSelected as removeSelectedRasterEdit } from "../state/existingRasterEditsMenu";
import {
  LeftRibbonButtonType,
  SelectionType,
  Tool,
  getActiveSelectionType,
  getActiveTool,
  setActiveSelectionType,
  setActiveSelectionTypeNone,
  setActiveTool,
  setActiveToolNone,
} from "../state/mainGui";
import { remove as removeProfileLine } from "../state/mapProfileLine";
import { remove as removeSelectedAsset } from "../state/selectedAsset";
import { removeXY } from "../state/selectedPoint";

import iconButtonStyles from "./IconButton.module.css";

const getIcon = (LeftRibbonButtonType: LeftRibbonButtonType | null) => {
  if (LeftRibbonButtonType === "INFO") return InfoIcon;
  if (LeftRibbonButtonType === "SELECTION") return SelectionToolIcon;
  if (LeftRibbonButtonType === "LINE_SELECTION") return LineIcon;
  if (LeftRibbonButtonType === "DISCHARGE") return DischargeIcon;
  if (LeftRibbonButtonType === "PUMP") return PumpIcon;
  if (LeftRibbonButtonType === "RAIN") return RainIcon;
  if (LeftRibbonButtonType === "WIND") return WindIcon;
  if (LeftRibbonButtonType === "RASTER_EDIT") return RasterEditIcon;
  if (LeftRibbonButtonType === "LEVEE_TOOL") return LeveeEditIcon;
  if (LeftRibbonButtonType === "LAYERS") return MapIcon;
  if (LeftRibbonButtonType === "EXPORT") return DownloadIcon;
  return DownloadIcon;
};

interface Props {
  setActiveTool: (scenarioEditMenu: Tool) => void;
  setActiveToolNone: () => void;
  setActiveSelectionType: (activeSelectionType: SelectionType) => void;
  setActiveSelectionTypeNone: () => void;
  scenarioEditMenu: LeftRibbonButtonType;
  tooltip: string;
  removeProfileLine: () => void;
  removeSelectedAsset: () => void;
  removeXY: () => void;
  removeSelectedRasterEdit: () => void;
}

const ToolIcon: React.FC<Props> = (props) => {
  const { scenarioEditMenu, tooltip } = props;
  const Icon = getIcon(scenarioEditMenu);
  const openedScenarioEditMenu = useSelector(getActiveTool);
  const activeSelectionType = useSelector(getActiveSelectionType);
  const isActiveTool = scenarioEditMenu === openedScenarioEditMenu;
  const isActiveSelectionType = activeSelectionType === scenarioEditMenu;
  const isSelectionTypeIcon =
    scenarioEditMenu === "SELECTION" || scenarioEditMenu === "LINE_SELECTION";

  return (
    <button
      className={`${iconButtonStyles.Button} ${iconButtonStyles.Sidebarbutton} ${
        isActiveTool || isActiveSelectionType
          ? iconButtonStyles.Highlighted
          : iconButtonStyles.NotHighlighted
      }`}
      onClick={() => {
        if (isSelectionTypeIcon) {
          if (isActiveSelectionType) {
            // props.setActiveSelectionTypeNone();
            // currently clicking on an openend selection type should not close it. Maybe we will change that later
            console.log(
              "currently clicking on an openend selection type should not close it. Maybe we will change that later"
            );
          } else {
            // @ts-ignore
            props.setActiveSelectionType(scenarioEditMenu);
            props.removeSelectedAsset();
            props.removeXY();
            props.removeProfileLine();
          }
        } else {
          if (isActiveTool) {
            // clicking on an open tool will close the tool
            props.setActiveToolNone();
            props.removeSelectedRasterEdit();
          } else {
            // @ts-ignore
            props.setActiveTool(scenarioEditMenu);
            props.removeSelectedRasterEdit();
          }
        }
      }}
      title={tooltip}
    >
      {/* this span is needed to scale icons in chrome browser. Previously it was not needed. It is not clear when this bug is introduced, or how it originally worked */}
      <span className={iconButtonStyles.ButtonSpan}>
        <Icon />
      </span>
    </button>
  );
};

export default connect(null, {
  setActiveTool,
  setActiveToolNone,
  setActiveSelectionType,
  setActiveSelectionTypeNone,
  removeProfileLine,
  removeSelectedAsset,
  removeXY,
  removeSelectedRasterEdit,
})(ToolIcon);
